var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoChatMessageDelivered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 12,
    viewBox: "0 0 25 12",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.6247.111434c.254.187208.3082.544932.121.798999l-7.99995 10.857067c-.09224.1252-.2315.2074-.38567.2276-.15416.0203-.30992-.0232-.43133-.1203l-5.714269-4.57143c-.2464351-.19715-.2863903-.55675-.089243-.80318.197148-.24643.556742-.28639.803177-.08924l1.999925 1.59994c1.77369 1.41895 4.37159 1.07795 5.719-.75068l5.17836-7.027716c.1872-.2540676.5449-.308268.799-.12106z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.7647.111434c.254.187208.3082.544932.121.798999l-8 10.857067c-.0922.1252-.2315.2074-.3856.2276-.1542.0203-.3099-.0232-.4314-.1203l-5.7142-4.57143c-.2465-.19715-.2864-.55675-.0893-.80318.1972-.24643.5568-.28639.8032-.08924l1.9999 1.59994c1.7737 1.41895 4.3716 1.07795 5.719-.75068l5.1784-7.027716c.1872-.2540676.5449-.308268.799-.12106z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChatMessageDelivered);
export default __webpack_public_path__ + "static/media/ico_chat_message_delivered.c05852c629670b7363c721c393fb6289.svg";
export { ForwardRef as ReactComponent };